export enum HeaderClassName {
  Base = "ticker-selector",
}
